import * as fetchIntercept from 'fetch-intercept';
import { ENV } from "../env";

const getCsrfToken = (name) => {
    const parts = document.cookie.split(`${name}=`);

    if (parts?.length === 2) {
        return parts?.pop()?.split(';').shift() || "";
    }
};

export default () => {
    fetchIntercept.register({
        request: (url, config) => {
            const resultConfig = config || {};
            const headers = resultConfig.headers || {};
            const method = resultConfig.method || 'GET';

            const methodsToIntercept = ['post', 'put', 'delete'];

            if (methodsToIntercept.indexOf(method.toLowerCase()) !== -1) {
                const csrfToken = getCsrfToken(
                    ENV.REACT_APP_CSRF_COOKIE_NAME || 'GBCSRF'
                );
                headers['CSRF-TOKEN'] = csrfToken;
            }

            resultConfig.headers = headers;

            return [url, resultConfig];
        }
    });
};